import { useState } from "react";
import { useBoolean } from "usehooks-ts";

import { useVideoEditorState } from "../state";
import { VideoEditorFile } from "../types";

interface UseVideoEditorDialogReturn {
  showVideoEditor: boolean;
  openVideoEditor: () => void;
  closeVideoEditor: () => void;
  pendingFile: VideoEditorFile | null;
  handleFileSelectedForEditing: (fileToEdit: VideoEditorFile) => void;
}

export const useVideoEditorDialog = (): UseVideoEditorDialogReturn => {
  const { resetState } = useVideoEditorState();

  const {
    value: showVideoEditor,
    setTrue: openVideoEditor,
    setFalse: closeVideoEditor,
  } = useBoolean(false);

  const [pendingFile, setPendingFile] = useState<VideoEditorFile | null>(null);

  const handleFileSelectedForEditing = (fileToEdit: VideoEditorFile) => {
    setPendingFile(fileToEdit);
    openVideoEditor();
  };

  const handleCloseVideoEditor = () => {
    setPendingFile(null);
    closeVideoEditor();
    resetState();
  };

  return {
    showVideoEditor,
    openVideoEditor,
    closeVideoEditor: handleCloseVideoEditor,
    pendingFile,
    handleFileSelectedForEditing,
  };
};
